<template >
    <div style="">
        <div  >

            <div style="top:-156px;position:fixed;width:100%;">
                <div style="z-index:0;position:relative;width:100%;height:calc(100vh + 200px);margin-left:0;background: rgb(154,255,186);background: linear-gradient(40deg, rgb(255 255 255 / 72%) 0%, rgb(2 4 4) 100%);">
                    <video  loop="" muted="" autoplay=""  style="opacity: 0.2;pointer-events: none;z-index: -1;height:calc(100vh + 200px);">">
                        <source :src="require('../assets/white_flare.webm')" type="video/webm">

                    </video>



                </div>




            </div>
            <v-row
                    align="center"
                    justify="center"

                    class="mx-auto"
                    style="height:80vh;top:0;z-index: 0;position: fixed;width:100%;"

            >


                <v-col align="center"  style="max-width:600px;background: rgba(129, 134, 169, 0.34); border-radius: 20px;padding:20px;" >
                    <h1 class="display-3 font-weight-bold mb-3 text--uppercase" >Spons!</h1>

                    <h3 class="font-weight-light" style="margin-top:40px;"> Tänk dig sponsorskap som naturligt och interaktivt blir innehåll dina tittare uppskattar. Det är Hihat Spons. </h3>

                    <span>
                    <v-btn  href="https://discord.com/invite/W6PHc2h" target="_blank" block class="mx-auto my-12" x-large dark style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" color="teal"> <v-icon>mdi-discord</v-icon>Gå med </v-btn>

                </span>


                </v-col>

            </v-row>



            <svg  :style="{'margin-top':$vuetify.breakpoint.mdAndUp? '500px':'650px'}"  style="position:relative;z-index: 1;margin-bottom:0;pointer-events: none;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#e7e7e7" fill-opacity="1" d="M0,32L48,26.7C96,21,192,11,288,53.3C384,96,480,192,576,218.7C672,245,768,203,864,192C960,181,1056,203,1152,197.3C1248,192,1344,160,1392,144L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>

            </svg>


            <div style="background:#e7e7e7;position:relative;">
            <v-row align="center" justify="center" class="mx-auto" style="position: relative;margin-top: -8px;z-index: 1;padding-bottom:80px;max-width:1200px;">

                <v-col   :cols="$vuetify.breakpoint.mdAndUp?'6':'12'">
                    <v-card
                            class="mx-auto px-4"
                            max-width="500"
                    >
                        <v-list-item>
                            <v-list-item-content>
                                <v-img
                                        src="/api/images/logo-utbildning_small.png"
                                        height="25"
                                        contain
                                        style="margin-top:10px;"
                                ></v-img>

                                <v-list-item-subtitle style="text-align: center;">önskar sponsra dig!</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-card-subtitle style="opacity:0.8;padding-bottom: 0;">Syfte</v-card-subtitle>
                        <v-card-text style="color:black;padding-top: 0;">
                            Blocket önskar genom detta sponsorskap informera om det stora utbud av utbildningar som finns tillgängliga på <a href="https://utbildning.blocket.se">utbildning.blocket.se</a>. Med denna overlay kommer chatten få rösta fram ditt framtida yrke!
                        </v-card-text>
                        <v-card-subtitle style="opacity:0.8;padding-bottom: 0;">Krav för sponsorskap</v-card-subtitle>
                        <v-card-text style="color:black;padding-top: 0;">
                            <v-list disabled>
                                <v-list-item-group >
                                    <v-list-item

                                    >
                                        <v-list-item-icon class="ma-0">
                                            <v-icon small >mdi-circle-slice-8</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="ma-0">
                                            <p>Följ reglerna för Hihat-Spons</p>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item

                                    >
                                        <v-list-item-icon class="ma-0">
                                            <v-icon small >mdi-circle-slice-8</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="ma-0">
                                            <p style="overflow:visible;white-space:break-spaces;">Kommunicera med dina tittare! Har chatten rätt i sitt siande? Varför? Varför inte?</p>
                                        </v-list-item-content>
                                    </v-list-item>

                                </v-list-item-group>
                            </v-list>

                        </v-card-text>
                        <v-card-subtitle style="opacity:0.8;padding-bottom: 0;padding-top:0;">Ersättning</v-card-subtitle>
                        <v-card-text>
                            <v-skeleton-loader
                                    class=""
                                    tile
                                    style="max-width:200px;"
                                    type="heading"
                            ></v-skeleton-loader>
                        </v-card-text>







                        <v-card-actions>
                            <v-btn dark block color="green" >Tacka Ja</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>

                <v-col   :cols="$vuetify.breakpoint.mdAndUp?'6':'12'">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <v-card-text>
                            Med Hihat Spons får du som streamer varje vecka erbjudanden om sponsoravtal.<br> Om erbjudandet låter intressant, är det bara att tacka ja!
                        </v-card-text>

                    </v-card>
                </v-col>

                <v-col   :cols="$vuetify.breakpoint.mdAndUp?'6':'12'">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <v-card-text>
                            Det sponsrade materialet börjar efter att ett erbjudande accepterats rulla automatiskt i din stream, eller när du vill genom kommandon i chatten.
                        </v-card-text>

                    </v-card>
                </v-col>
                <v-col  :cols="$vuetify.breakpoint.mdAndUp?'6':'12'">
                    <SponsComponent  v-on:vote="vote"></SponsComponent>

                </v-col>

                <v-col   :cols="$vuetify.breakpoint.mdAndUp?'6':'12'">
                    <div  style="margin: auto; height: 377px; width: 341px; background-image: url('/api/images/chat_bg_white.png'); border-radius: 4px;">
                        <div id="chat_list" style="left:15px;top:75px;position: relative;text-align: left;height: 200px; overflow: overlay;width: 325px;" >
                            <v-list-item v-for="(vote,index) in votes" :key=index class="pl-0">
                                <v-list-item-content>
                                    <v-list-item-title style="overflow: visible; white-space: break-spaces;font-size:14px;"><b :style="{'color':colors[index % colors.length]}">{{vote[1]}}</b> {{vote[0]}}!</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                        </div>
                    </div>
                </v-col>

                <v-col   :cols="$vuetify.breakpoint.mdAndUp?'6':'12'">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <v-card-text>
                            Engagera och locka tittare med exklusiva giveaways från Hihat-partners, där Hihat sköter all logistik.
                        </v-card-text>

                    </v-card>
                </v-col>



            </v-row>
            </div>







        </div>


    </div>
</template>
<script>
    import SponsComponent from "../components/SponsComponent";
    export default {
        name: 'Home',
        components: {
            SponsComponent
        },
        data(){
            return{
                votes:[],
                colors:[
                    "red",
                    "blue",
                    "green",
                    "purple",
                    "orange",
                    "darkgreen",
                    "aquamarine",
                    "teal"
                ],
                tab:0
            }

        },
        computed:{

            minHeight () {
                const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

                return `calc(${height} - ${this.$vuetify.application.top}px)`
            },


        },
        methods:{
            letsgo:function(){
                this.$store.state.APP.SHOW_LOGIN=true;
            },
            letsgome:function(){
                this.$router.push({ path: `/${this.$store.state.STYLE.PATH}` })

            },
            vote(payload){
                this.votes.push(payload);
                updateScroll();
            }


        },
        mounted:function(){
            document.title="Hihat";
            let self=this;
            setTimeout(function(){
                self.votes.push(["Vad gör egentligen Guthen i framtiden? Rösta genom !1 eller !2","Spons-bot"])
            },1500)


        }

    }

    var scrolled = false;
    function updateScroll(){
        if(!scrolled){
            var element = document.getElementById("chat_list");
            element.scrollTop = element.scrollHeight;
        }
    }

    $("#chat_list").on('scroll', function(){
        scrolled=true;
    });
</script>

<style scoped>
    .lift_me_up> * img{
        top:-200px;
    }

    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .spin_da_guthen{
        animation-name: spin;
        animation-duration: 1000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        /* transform: rotate(3deg); */
        /* transform: rotate(0.3rad);/ */
        /* transform: rotate(3grad); */
        /* transform: rotate(.03turn);  */
    }

    .theme--dark.v-data-table tbody tr:hover{
        background: rgba(255,255,255,0.1) !important;
    }

    .v-list-item__content{
        padding:0;
        margin-bottom:8px;
    }
    .v-list-item{
        min-height:10px;
    }

    #chat_list::-webkit-scrollbar-thumb{
        background: rgba(158, 159, 153, 0.26) !important;
    }
    /* Track */
    #chat_list::-webkit-scrollbar-track {
        background: #f1f1f1 !important;
    }

    /* Handle */
    #chat_list::-webkit-scrollbar-thumb {
        background: #373834 !important;
    }

    /* Handle on hover */
    #chat_list::-webkit-scrollbar-thumb {
        background: rgba(158, 159, 153, 0.26) !important;
    }
    #chat_list::-webkit-scrollbar-thumb:hover {
        background: rgba(158, 159, 153, 0.40) !important;
    }


    #chat_list::-webkit-scrollbar {
        width:10px !important;
    }
</style>
